export default "__VITE_ASSET__785UPLWG__"